import React, { FunctionComponent } from 'react';
import { Serie } from '@nivo/line';

import DefaultLineChart from '../default-line-chart';

type Props = {
  data: Serie[];
};

const SmsReceivedGraphView: FunctionComponent<Props> = ({ data }) => {
  return <DefaultLineChart data={data} colors={['#5500FF', '#CBB4F9']} />;
};

export default SmsReceivedGraphView;
